import { props, state } from 'cerebral'
import { set, when } from 'cerebral/factories'
import { compose, path, pluck } from 'ramda'
import * as actions from './actions'
import { saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'
import { loadProfilesSequence } from '../profiles/factories'

const loadProfiles = loadProfilesSequence(compose(pluck('profile'), path(['props', 'entities', 'serviceRequests'])), 'profileIds')
const loadPendingRequestProfiles = loadProfilesSequence(compose(pluck('profile'), path(['props', 'pendingRequests'])), 'profileIds')

export const find = [
  //
  actions.find,
  saveEntities(),
  when(props`skipProfileLoad`),
  {
    true: [],
    false: loadProfiles,
  },
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  actions.find,
  actions.setList,
  saveEntities(),
  loadProfiles,
]

export const get = [
  //
  actions.get,
  saveEntities(),
  loadProfiles,
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Service request has been saved', type: 'success' }),
  route.toServiceRequests,
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Service request has been deleted', type: 'success' }),
  findForList,
]

export const syncPendingRequests = [
  //
  when(state`account.currentUser.canAccessCommandCenter`),
  {
    true: [
      when(state`account.packages.service-requests`),
      {
        true: [
          //
          actions.syncPendingRequests,
          loadPendingRequestProfiles,
        ],
        false: [],
      },
    ],
    false: [],
  },
]

export const updateEntities = [
  //
  saveEntities(),
]

export const updateList = [
  //
  actions.setList,
]

export const acknowledgeServiceRequest = [
  //
  actions.acknowledgeServiceRequest,
  saveEntities(),
  showFeedback({ title: 'Service request has been acknowledged', type: 'success' }),
]

export const dismissServiceRequest = [
  //
  actions.dismissServiceRequest,
  saveEntities(),
  showFeedback({ title: 'Service request has been dismissed', type: 'success' }),
]

export const addUniqueServiceRequest = [
  //
  syncPendingRequests,
  actions.addItemToList,
  actions.setList,
  saveEntities(),
]
